import { dictRuStep1 } from '../steps/01_preparations/translation/dictRuStep1';
import { dictRuStep2 } from '../steps/02_shipment-details/translation/dictRuStep2';

export const dictRu = {
  ...dictRuStep1,
  ...dictRuStep2,
  Edit: 'Изменить',
  Delete: 'Удалить',
  Next: 'Далее',
  Other: 'Другое',
  Close: 'Закрыть',
  Required: 'обязательно для заполнения',
  NotCorrectEmail: 'некорректный формат email',
  NotCorrectPhone: 'некорректный формат телефона',
  NotCorrectINN: 'некорректный формат ИНН',
  NotCorrectKPP: 'некорректный формат КПП',
  NotCorrectDeliveryTypeText:
    'Описание должно быть подробным и указано на английском языке!',
  minTextLength: 'Минимум {number} символов',
  maxTextLength: 'Максимум {number} символов',
  LatinOnly: 'Разрешена только латиница',
  CyrillicOnly: 'Разрешена только кириллица',
  LatinOnlyPopup: 'Отправитель – иностранец. Введите его данные на английском.',
  Error: 'К сожалению, произошла ошибка',
  notRequired: 'Заполнять не обязательно',
  IataCodeErrorTitle: 'Уважаемый клиент!',
  IataCodeErrorText:
    '<p>В связи с проведением технических работ расчет стоимости и сроков доставки по данному направлению недоступен до 12 января 2020.</p><p> Просим вас обратиться в отдел по работе с клиентами по телефону <span>[!phone!]</span>.</p><p>Приносим извинения за возможные неудобства.</p><p>Команда DHL.</p>',
  ConfirmModalYes: 'Да',
  ConfirmModalNo: 'Нет',
  BoxAttentionText:
    'Внимание! Упаковка должна быть прочной, надежной и предохранять груз от повреждения. Размер упаковки должен позволять разместить на одной из сторон накладную размером 15x21 см.',
  MarketingNewsletterAllowed: 'Согласие на рассылку маркетинговых материалов.',
  Invoice: 'Инвойс',
  MarketingNewsletterAllowed: 'Согласие на рассылку маркетинговых материалов.',
};

export default {
  dictRu,
};
